import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DatiqLinkModule } from '@dat/datiq-components-pkg/link';
import { DatiqButtonActionComponent } from './components/datiq-button-action/datiq-button-action.component';
import { DatiqButtonLinkComponent } from './components/datiq-button-link/datiq-button-link.component';
import { DatiqButtonComponent } from './components/datiq-button/datiq-button.component';

@NgModule({
    imports: [CommonModule, MatButtonModule, DatiqLinkModule, MatIconModule],
    declarations: [
        DatiqButtonActionComponent,
        DatiqButtonComponent,
        DatiqButtonLinkComponent,
    ],
    exports: [
        DatiqButtonActionComponent,
        DatiqButtonComponent,
        DatiqButtonLinkComponent,
    ],
})
export class DatiqButtonModule {}
